import React from 'react';
import AlertIcon from 'assets/icons/icon-alert-msg.svg';
import PropTypes from 'prop-types';
import './AcceptTermsMessage.scss';

export const AcceptTermsMessage = ({ text }) => (
    <div className="accept-terms-message-container">
        <img alt="alert-icon" src={AlertIcon} />
        {text}
    </div>
);

AcceptTermsMessage.proptypes = {
    text: PropTypes.string,
};
